module.exports = __webpack_public_path__ + "img/conexion.7ac6b6c9.png";